import defaultState from '../defaultState';

const defaultAuthentication = defaultState.authentication;

export default function authentication(state = defaultAuthentication, action) {
  switch (action.type) {
    case 'REQUESTING_LOGIN':
      return {
        ...state,
        isFetching: true,
        error: null
      };

    case 'SET_TOKEN':
      return {
        ...state,
        token: action.token,
        user: action.user
      };

    case 'UPDATE_LOGGED_IN_USER':
      return {
        ...state,
        user: { ...state.user, ...action.user }
      };

    case 'SET_TOKEN_CONTENT':
      return {
        ...state,
        tokenContent: action.tokenContent,
        isLoggedIn: true,
        isFetching: false
      };

    case 'UNAUTHORISED_GLOBAL_ACCESS':
      return {
        ...state,
        error: 'You do not have permission to access that page.'
      };

    case 'CLEAR_ACCESS_ERROR':
      return {
        ...state,
        error: null
      };

    case 'LOGIN_ERROR':
      console.error('error: ', action.error);
      return {
        ...state,
        isFetching: false,
        isLoggedIn: false,
        user: {},
        error: action.error
      };

    case 'LOGOUT':
      return defaultAuthentication;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authentication.js